/**
 * UNIVAPLAT-3689: command (write) models for the admin organisation endpoints
 * (`/api/v2/organisations`, backend contract UNIVAPLAT-3665).
 *
 * The reason is PHI-adjacent: never log it (Sentry breadcrumbs included).
 */

/** Longest deactivation or deletion reason the UI accepts (the backend column is 255). */
export const ORGANISATION_REASON_MAX_LENGTH = 255;

/** Body of `POST /api/v2/organisations`. Maximum lengths: name 100, code 10, address 100, city 50, postcode 20. */
export interface OrganisationCreate {
    name: string,
    code: string,
    address?: string | null,
    city?: string | null,
    postcode?: string | null,
}

/**
 * Body of `PUT /api/v2/organisations/{id}`. `code` is sent only by general admins;
 * omit it for organisation admins (the backend rejects it for them).
 */
export interface OrganisationUpdate {
    name: string,
    address?: string | null,
    city?: string | null,
    postcode?: string | null,
    code?: string,
}

/** Body of `PATCH /api/v2/organisations/{id}/deactivate`. */
export interface OrganisationDeactivate {
    reason?: string,
}

/** Body of `DELETE /api/v2/organisations/{id}`. */
export interface OrganisationDelete {
    reason?: string,
}

/** Body of `POST /api/v2/organisations/{id}/contracts`. */
export interface OrganisationContractsAdd {
    contractIds: number[],
}

/** Body of `POST /api/v2/organisations/{id}/care-programs`. */
export interface OrganisationCareProgramsAdd {
    careProgramIds: number[],
}

/** Body of `POST /api/v2/organisations/{id}/services`. */
export interface OrganisationServicesAdd {
    serviceIds: number[],
}

/** Body of `POST /api/v2/organisations/{id}/admins`: user ids. */
export interface OrganisationAdminsAdd {
    organisationAdmins: number[],
}

/** Body of `POST /api/v2/contracts/{id}/organisations`. */
export interface ContractOrganisationsAdd {
    organisationIds: number[],
}
